export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  stickyHeaders: false,
  customRowKey: 'uid',
  toolBar: false,
  fields: [
    {
      name: 'field-generic-input',
      width: '60%',
      title: 'Item',
      prop: 'name',
      id: '',
    },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'Total Prod. QTY',
      prop: 'quantity',
      id: '',
    },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'QTY Complete',
      prop: 'quantity',
      id: '',
    },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'QTY Shipped',
      prop: 'serials.unavailable',
      id: '',
    },
    {
      name: 'field-generic-input',
      width: '10%',
      title: 'QTY Avail To Ship',
      prop: 'serials.available',
      id: '',
    },
  ],
};
